import {
  Checkbox,
  Typography,
  TextField,
  makeStyles,
  FormControlLabel,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { classes as workerStyles } from "../AddWorkerStyles";
import React, { useEffect, useState } from "react";
import { getLocationForCountry } from "services/bulkUpload";
import { Controller, useFormContext } from "react-hook-form";
import { isEmptyObject } from "utils";
import { useTranslation } from "react-i18next";
import { properCase } from "utils";

const useStyles = makeStyles((theme) => workerStyles(theme));

const TransportUserAccess = ({
  selectedWorker,
  manager,
  initialValue,
  setTransportValid,
  setIsTransportWorker,
}) => {
  const classes = useStyles();
  const { control, setValue, getValues, errors, clearErrors } =
    useFormContext();

  const [districts, setDistricts] = useState([]);
  const [isActiveTicked, setIsActiveTicked] = useState(false);
  const [isDistrictRestricted, setIsDistrictRestricted] = useState(false);
  const [transportDistrict, setTransportDistrict] = useState([]);
  const [transportRole, setTransportRole] = useState(null);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    selectedWorker
      ? getLocationForCountry(
          //selectedWorker.worker?.countryCode,
          //selectedWorker.worker?.alternateCountryCode
        )
          .then((data) => {
            // const cleanData = data.map((item) =>  item.district);
            // setDistricts(cleanData);
            let transportDistricts = [];
            data.forEach((record) => {
              let DistTransportEnabled = false;
              Object.entries(record.buildings).map((buildingDet) => {
                if (
                  buildingDet[1].transportEnabled === true
                ) {
                  DistTransportEnabled = true;
                }
              });
              if(DistTransportEnabled && record.district){
                transportDistricts.push(record.district);
              }
              record.DistTransportEnabled = DistTransportEnabled;
            });
            setDistricts([...transportDistricts]);
          })
          .catch((err) => {
            console.log("Get districts in transport ", err);
          })
      : getLocationForCountry(
          //manager?.countryCode,
          //manager?.alternateCountryCode
        )
          .then((data) => {
            // const cleanData = data.map((item) => item.district);
            // setDistricts(cleanData);
            let transportDistricts = [];
            data.forEach((record) => {
              let DistTransportEnabled = false;
              Object.entries(record.buildings).map((buildingDet) => {
                if (
                  buildingDet[1].transportEnabled === true
                ) {
                  DistTransportEnabled = true;
                }
              });
              if(DistTransportEnabled && record.district){
                transportDistricts.push(record.district);
              }
              record.DistTransportEnabled = DistTransportEnabled;
            });
            setDistricts([...transportDistricts]);
          })
          .catch((err) => {
            console.log("Get districts in transport ", err);
          });
  }, []);

  useEffect(() => {
    if (!isEmptyObject(initialValue)) {
      setValue("districtRestricted", initialValue.districtRestricted);
      setValue("isTransportActive", initialValue.isActive);
      setValue("transportDistrict", initialValue.trDistricts);
      setValue("transportRole", initialValue.role);
      setIsActiveTicked(initialValue?.isActive);
      setIsDistrictRestricted(initialValue?.districtRestricted);
      setTransportDistrict(initialValue?.trDistricts);
      setTransportRole(initialValue?.role);
    }
  }, [initialValue]);

  useEffect(() => {
    if (getValues("isTransportActive") || initialValue?.isActive) {
      setIsTransportWorker(true);
    } else {
      setIsTransportWorker(false);
    }
    setIsDistrictRestricted(isDistrictRestricted && isActiveTicked);
    setValue("districtRestricted", isDistrictRestricted);
  }, [isActiveTicked]);

  useEffect(() => {
    console.log("TRANSPORT ROLE ", getValues("transportRole"));
    if (getValues("isTransportActive")) {
      if (
        (getValues("transportDistrict")?.length === 0 &&
          getValues("districtRestricted")) ||
        getValues("transportRole")?.length === 0 ||
        getValues("transportRole") === null
      ) {
        setTransportValid(false);
      } else setTransportValid(true);
    } else {
      setTransportValid(true);
    }
  }, [
    getValues("transportDistrict"),
    getValues("districtRestricted"),
    getValues("transportRole"),
    getValues("isTransportActive"),
  ]);

  const districtValidation = (values) =>
    console.log(
      "error kraken",
      values.length !== 0 && getValues("districtRestricted")
    ) ||
    (values.length !== 0 && getValues("districtRestricted"));

  return (
    <>
      <Typography
        variant="h6"
        gutterBottom
        className={`${classes.employeeId} ${classes.title}`}
      >
        {t("other.lblTransportUserAccess")}
      </Typography>
      {/* Enable Transport */}
      <FormControlLabel
        control={
          <Controller
            name="isTransportActive"
            control={control}
            defaultValue={isActiveTicked}
            render={(props) => (
              <>
                <Checkbox
                  {...props}
                  checked={props.value}
                  onChange={(e) => {
                    setIsActiveTicked(e.target.checked);
                    setIsDistrictRestricted(e.target.checked);
                    props.onChange(e.target.checked);
                  }}
                  color="primary"
                  style={{ paddingLeft: 0 }}
                  inputRef={props.ref}
                />
              </>
            )}
          />
        }
        label={t("other.lblEnableTrasportAccess")}
      />

      {/* District Restricted */}
      <FormControlLabel
        control={
          <Controller
            name="districtRestricted"
            control={control}
            disabled={!isActiveTicked}
            defaultValue={isDistrictRestricted && isActiveTicked}
            render={(props) => (
              <>
                <Checkbox
                  {...props}
                  checked={props.value && isActiveTicked}
                  disabled={!isActiveTicked}
                  onChange={(e) => {
                    setIsDistrictRestricted(e.target.checked && isActiveTicked);
                    props.onChange(e.target.checked && isActiveTicked);
                  }}
                  color="primary"
                  style={{ paddingLeft: 0 }}
                  inputRef={props.ref}
                />
              </>
            )}
          />
        }
        label={t("other.lblDistrictRestricted")}
      />

      {/* Select Districts */}
      <Controller
        name="transportDistrict"
        control={control}
        defaultValue={transportDistrict}
        disabled={!isDistrictRestricted && !isActiveTicked}
        rules={{
          validate: getValues("districtRestricted") ? districtValidation : true,
        }}
        render={(props) => (
          <Autocomplete
            size="small"
            multiple
            style={{ marginTop: 20, marginBottom: 20 }}
            options={districts}
            value={props.value}
            disableClearable
            disabled={!isDistrictRestricted}
            renderInput={(params) => (
              <TextField
                {...params}
                // {...props}
                style={{ maxWidth: 300 }}
                id="transportDistrict"
                name="transportDistrict"
                label={properCase( props.value.length > 0 ? t( "other.lblDistrict") : t( "general.select1" ))}
                required={getValues("districtRestricted")}
                error={
                  Boolean(errors.transportDistrict) && isDistrictRestricted
                }
                helperText={
                  errors?.transportDistrict?.type === "validate"
                    ? "District cannot be blank"
                    : ""
                }
              />
            )}
            onChange={(e, val) => {
              props.onChange(val);
            }}
          />
        )}
      />

      {/* Select Role */}

      <Controller
        name="transportRole"
        control={control}
        defaultValue={transportRole}
        disabled={!isActiveTicked}
        rules={isActiveTicked ? { required: "Role cannot be blank" } : false}
        render={(props) => (
          <Autocomplete
            size="small"
            style={{ marginTop: 20, marginBottom: 20 }}
            options={["Supervisor", "Care", "Driver", "RPL"]}
            value={props.value}
            disableClearable
            disabled={!isActiveTicked}
            renderInput={(params) => (
              <TextField
                {...params}
                // {...props}
                style={{ maxWidth: 300 }}
                id="transportRole"
                name="transportRole"
                label={properCase( props.value ? t( "other.lblRole") : t( "other.lblSelectRole" ))}
                required={getValues("isTransportActive")}
                error={Boolean(errors.transportRole) && isActiveTicked}
                helperText={errors.transportRole?.message}
              />
            )}
            onChange={(e, val) => {
              props.onChange(val);
            }}
          />
        )}
      />
    </>
  );
};

export default TransportUserAccess;
